// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PxBg","type":"styles_type__3YdMv","choices":"styles_choices__uyXD4"};